import logger from '../lib/logger';
import { IS_PC, IS_RN } from '../constants';
var toastDom = null;
var toastText;
var toastIcon = null;
var isToast = false;
var lastTimer = null;
var AniTime = 320;
var ErrorImage = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Ccircle cx='9' cy='9' r='8' fill='%23FF6647'/%3E%3Crect width='1.5' height='5' rx='.75' transform='matrix(1 0 0 -1 8.25 13)' fill='%23fff'/%3E%3Ccircle cx='.75' cy='.75' r='.75' transform='matrix(1 0 0 -1 8.25 6.5)' fill='%23fff'/%3E%3C/svg%3E";
var BaseStyle = "\n  position: fixed;\n  left: 50%;\n  transform: translateX(-50%);\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  z-index: 100000;\n";
var MobileStyle = "\n  ".concat(BaseStyle, "\n  bottom: 20%;\n\n  height: 40px;\n  padding: 0 18px;\n  border-radius: 6px;\n  background-color: #6b6b6b;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  color: #fff;\n\n  transition: all ").concat(AniTime, "ms ease-in-out;\n  opacity: 0;\n");
var PCStyle = "\n  ".concat(BaseStyle, "\n  top: 108px;\n  max-width: 708px;\n  height: 44px;\n  padding: 12px 16px;\n  border-radius: 12px;\n  background-color: #6b6b6b;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.4px;\n  color: #fff;\n\n  transition: all ").concat(AniTime, "ms cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  transform: translateX(-50%) translateY(-10px);\n  opacity: 0;\n");
var Style = IS_PC ? PCStyle : MobileStyle;
// TODO: ios 和 android 缺少相关 bridge 因此走 web 流程
export var showToast = function (text, timeout, type) {
    if (timeout === void 0) { timeout = 2000; }
    if (!text)
        return;
    // TODO: IS_APP
    if (IS_RN) {
        logger.error('showToast is not support RN Env');
        return;
    }
    if (!toastDom) {
        toastDom = document.createElement('div');
        toastText = document.createElement('span');
        toastText.setAttribute('style', "overflow: hidden; white-space: nowrap; text-overflow: ellipsis;");
        toastText.innerText = text;
        toastDom.appendChild(toastText);
        toastDom.setAttribute('style', Style);
    }
    else {
        toastText.innerText = text;
    }
    // let clearTimer = null
    if (isToast) {
        resetToast(toastDom);
        lastTimer && clearTimeout(lastTimer);
    }
    // add toast icon
    if (type) {
        toastIcon = document.createElement('div');
        toastIcon.style.setProperty('background-image', "url(\"".concat(ErrorImage, "\")"));
        toastIcon.style.setProperty('width', '18px');
        toastIcon.style.setProperty('height', '18px');
        toastIcon.style.setProperty('margin-right', '8px');
        toastDom.insertBefore(toastIcon, toastText);
    }
    isToast = true;
    document.body.appendChild(toastDom);
    lastTimer = setTimeout(function () {
        startToast(toastDom);
        lastTimer = setTimeout(function () {
            hideToast(toastDom);
            lastTimer = setTimeout(function () {
                toastDom === null || toastDom === void 0 ? void 0 : toastDom.remove();
                resetToast(toastDom);
            }, AniTime);
        }, timeout + AniTime);
    }, 0);
};
export var showErrorToast = function (text, timeout) {
    return showToast(text, timeout, 'error');
};
var startToast = function (toastDom) {
    if (!toastDom)
        return;
    if (IS_PC) {
        toastDom.style.opacity = '1';
        toastDom.style.transform = 'translateX(-50%) translateY(0px)';
    }
    else {
        toastDom.style.opacity = '1';
    }
};
var hideToast = function (toastDom) {
    if (!toastDom)
        return;
    toastDom.style.opacity = '0';
};
var resetToast = function (toastDom) {
    if (!toastDom)
        return;
    toastDom === null || toastDom === void 0 ? void 0 : toastDom.setAttribute('style', Style);
    if (toastIcon) {
        toastIcon.remove();
        toastIcon = null;
    }
};
